import ujs from "@rails/ujs"

class @App.Pages.VideosIndex
  constructor: ->
    @search_steps = new App.Components.VideoSearchSteps
    @video_preview = new App.Components.VideoPreview
    @video_grid = new App.Components.VideoGrid
    @loading = new App.Components.VideoSearchLoading
    @pagination = new App.Components.VideoSearchPagination
    @video_search = new App.Components.VideoSearch
    @query_input = $('#video_search').find('input[name="q"]')

    $(document).on 'App::Components::VideoSearch::search_submit', (e) ->
      $('.new-users-alert').hide()
      # History.pushState(
      #   { search: e.search_query },
      #   null,
      #   "?search=#{encodeURIComponent(e.search_query)}"
      # )

    $(document).on 'click', '.new-users-alert .icon-remove', (e) ->
      $('.new-users-alert').hide()

    $(document).on 'click', '.video-grid-item', (e) =>
      $el = $(e.currentTarget)
      youtube_id = $el.data('youtube-id')
      video_url = $el.data('url')
      prev_url = $el.data('prev-url')
      next_url = $el.data('next-url')

      @video_preview.show
        youtube_id: youtube_id
        url: video_url
        prev_url: prev_url
        next_url: next_url
        form_authenticity_token: $('meta[name="csrf-token"]').attr('content')

      # Update the url
      q = $.querystring['search'] or @query_input.val() or youtube_id

      History.pushState(
        { video: youtube_id }, null, "?search=#{q}&video=#{youtube_id}")

    if $.querystring['search']
      q = $.querystring['search']
      @query_input.val(q)

      # show modal with video
      if $.querystring['video']
        @query_input.parents('form').bind 'ajax:complete', ->
          selected_item =
            $('div[data-youtube-id="' + $.querystring['video'] + '"]')
          selected_item.click() # triggers show

    if $.querystring['search']
      form = @query_input.parents('form').get(0)
      ujs.fire(form, 'submit')

    if $.querystring['video'] and !$.querystring['search']
      @query_input.val($.querystring['video'])

    $(document).on 'click', '.js-back-to-search-results', (e) =>
      e.preventDefault()

      @video_preview.hide()
      @video_grid.show()

      if @video_grid.isEmpty()
        if @query_input.val() == ''
          @query_input.val($.querystring['video'])
        form = @query_input.parents('form').get(0)
        ujs.fire(form, 'submit')

$ ->
  new App.Pages.VideosIndex if $(document.body).hasClass 'videosIndexView'
